import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction"
import ListItemText from "@material-ui/core/ListItemText"
import ListSubheader from "@material-ui/core/ListSubheader"

import IconButton from "@material-ui/core/IconButton"
import Tooltip from "@material-ui/core/Tooltip"
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf"
import WebIcon from "@material-ui/icons/Language"
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary"

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    //maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  listText: {
    //border: "2px red solid",
    maxWidth: "90%",
  },
}))

export default function SwitchListSecondary({ year, rows }) {
  const classes = useStyles()

  return (
    <List
      subheader={<ListSubheader>{year}</ListSubheader>}
      className={classes.root}
    >
      {rows.map((row) => (
        <ListItem key={row.title}>
          <ListItemText
            inset
            primary={row.title}
            secondary={row.note}
            className={classes.listText}
          />
          <ListItemSecondaryAction>
            {row.pdf && (
              <a href={row.pdf} target="_blank" rel="noopener noreferrer">
                <Tooltip title="View PDF">
                  <IconButton aria-label="view-pdf">
                    <PictureAsPdfIcon />
                  </IconButton>
                </Tooltip>
              </a>
            )}
            {row.link && (
              <a href={row.link} target="_blank" rel="noopener noreferrer">
                <Tooltip title="Website">
                  <IconButton aria-label="website-link">
                    <WebIcon />
                  </IconButton>
                </Tooltip>
              </a>
            )}
            {row.video && (
              <a href={row.video} target="_blank" rel="noopener noreferrer">
                <Tooltip title="Video">
                  <IconButton aria-label="video-link">
                    <VideoLibraryIcon />
                  </IconButton>
                </Tooltip>
              </a>
            )}
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  )
}
